import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../store';
import {conditional} from '../../util/conditional';
import {filterAndJoin} from '../../util/filterAndJoin';
import {pimText, pimTextDebug} from '../../util/values';
import {selectSpcConfiguration} from '../../selectors';

@customElement('shared-light-engine')
export class sharedLightEngine extends connect(store)(LitElement) {

	static styles = css`
		.pageContainer {
			display: flex;
			justify-content: space-between;
			width: 100%;
			gap: 1cqw;
			padding-top: 2cqw;
		}

		.image {
			container-type: inline-size;
			width: 30%;
		}

		.content {
			width: 70%;
		}

		.title {
			font: var(--font-specsheet-print-small-text);
			font-size: 0.91cqw;
		}

    `;
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.productData = this.state.productData;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}
	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}
	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.productData.translations, value, prefix, suffix);
	}
	render() {
		const s = this.state;
		return html`

			<div class="pageContainer">
				<div class="image">
					<shared-polar-diagram></shared-polar-diagram>
				</div>

				<div class="content">
					<div><strong><trans-label class="title" key="LE_LuminousFlux_OperatingTime" context="D"></trans-label></strong></div>
					<shared-llmf-table></shared-llmf-table>
				</div>


				</div>
			</div>

        `;
	}
}
